module.exports = __webpack_public_path__ + "posture/static/img/boneBackground.503aad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/bone/boneBackground.png
// module id = kufR
// module chunks = 1